<template>
  <div>
    <h1 class="headline font-weight-medium grey--text my-2">Recuperação de Senha</h1>

    <v-form class="px-12" ref="form" lazy-validation>
      <h1
        class="text-center subtitle-1 font-weight-medium grey--text my-2"
      >Agora digite o código de verificação enviado e, em seguida, a sua nova senha</h1>
      <v-text-field v-model="codeVerification" type="text" :rules="codeRules" label="Código de Verificação" outlined></v-text-field>
      <v-text-field
        v-model="newPassword"
        :rules="newPasswordRules"
        type="password"
        label="Nova Senha"
        outlined
      ></v-text-field>
      <v-text-field
        v-model="confirmPassword"
        type="password"
        label="Confirmar Nova Senha"
        :rules="[confirmPasswordRules]"
        outlined
      ></v-text-field>
      <v-container>
        <v-layout row wrap>
          <v-btn
            class="body-2 white--text"
            color="primary"
            width="120"
            height="45"
            depressed
            to="/"
          >Voltar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="body-2 white--text"
            color="primary"
            width="150"
            height="45"
            :loading="loading"
            depressed
            @click="recoveryPassword"
          >Recuperar Senha</v-btn>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "RecoveryPassword",
  data: () => ({
    newPassword: "",
    confirmPassword:undefined,
    loading:false,
    codeVerification: "",
    codeRules: [(v) => !!v || "Necessário preencher o código de verificação!"],
    newPasswordRules: [(v) => !!v || "Necessário preencher a nova senha!"],
  }),
  mounted() {
    window.addEventListener("keydown", this.handleEnter);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEnter);
  },
  computed: {
    confirmPasswordRules() {
      if (this.newPassword && !this.confirmPassword)
        return "Confirmar nova senha precisa ser preenchido!";
      if (
        this.newPassword &&
        this.confirmPassword &&
        this.confirmPassword != this.newPassword
      )
        return "As senhas são diferentes!";
      return null;
    },
  },
  methods: {
    handleEnter(e) {
      if (e.key === "Enter") {
        this.recoveryPassword();
      }
    },
    recoveryPassword() {
      if (this.$refs.form.validate()) {
          this.loading = true
        /* this.$store.dispatch("recoveryPassword", {
                    email: this.email
                }); */
        this.loading = false
        this.$router.push('success')
        //this.$router.push('error')
      }
    },
  },
};
</script>

<style>
</style>